export default __webpack_public_path__ + "static/media/call-add.5923db44.svg";